import React from 'react'
import styled from '@emotion/styled'
import { Link, useLocation } from 'react-router-dom'
import { createGaEvent } from '~/helpers/gaHelper'
import Menu from './Menu'
import getStraitsXNavigationLogo from '~/helpers/getStraitsXNavigationLogo'

type props = {
  displayEarnTab?: boolean
  displayGetStartedTab: boolean
  displayMintTab?: boolean
  displayDevToolTab?: boolean
  displayPlatformToolsTab?: boolean
  isSandbox: boolean
  displayAccountStatementTab?: boolean
  displayUserCardsTab?: boolean
  displayRfiManagementTab?: boolean
  disableStraitsxMenu?: boolean
  isOnboardingOperator?: boolean
  onClickCallbacks?: { [k: string]: Function } | undefined
}

export default function StraitsXNavigation({
  displayEarnTab = false,
  displayGetStartedTab = false,
  displayMintTab = false,
  displayDevToolTab = false,
  displayPlatformToolsTab = false,
  displayAccountStatementTab = false,
  displayUserCardsTab = false,
  displayRfiManagementTab = false,
  disableStraitsxMenu = false,
  isOnboardingOperator = false,
  onClickCallbacks,
  isSandbox,
}: props) {
  const { pathname } = useLocation()

  return (
    <SideContainer style={{ backgroundColor: isSandbox ? '#002B2A' : '#FFFFFF' }}>
      <FixedContainer>
        <LogoPanel>
          <Link
            to="/"
            onClick={() => createGaEvent('General', 'clickXfersLogoLink', 'Clicked Xfers Logo')}
          >
            {getStraitsXNavigationLogo({ isSandbox })}
          </Link>
        </LogoPanel>
        <Menu
          displayEarnTab={displayEarnTab}
          displayGetStartedTab={displayGetStartedTab}
          displayMintTab={displayMintTab}
          displayDevToolTab={displayDevToolTab}
          displayPlatformToolsTab={displayPlatformToolsTab}
          displayAccountStatementTab={displayAccountStatementTab}
          displayUserCardsTab={displayUserCardsTab}
          displayRfiManagementTab={displayRfiManagementTab}
          disableStraitsxMenu={disableStraitsxMenu}
          isOnboardingOperator={isOnboardingOperator}
          onClickCallbacks={onClickCallbacks}
          isSandbox={isSandbox}
          currentPathname={pathname}
        />
      </FixedContainer>
    </SideContainer>
  )
}

const SideContainer = styled.div`
  min-height: 100vh;
  width: 257px;
  flex: 1;
  flex-shrink: 0;
  display: block;

  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
  width: 257px;
`

const FixedContainer = styled.div`
  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
  width: 257px;
  overflow: hidden;
`

const LogoPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 45px;
`
